var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Welcome to Ascent...future stuff coming soon! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }